import { createSlice } from "@reduxjs/toolkit";

const trakingState = {
  trakingdata: {}
}

const trakingSlice = createSlice({
  name: 'trakings',
  initialState: trakingState,
  reducers: {
    storeDataTracking: (state, action) => action.payload,
  }
})

export const { storeDataTracking } = trakingSlice.actions;
export default trakingSlice.reducer;